import React from 'react';
import { MBIcon, MBIconProps, MBImage, MBImageProps } from '@shared/components/image';
import { MBTouchableOpacity } from './opacity';

interface SelectedButtonProps {
  disabled?: boolean;
  onPress?: (node: React.Component) => any;
}

type MBTouchableImageProps = MBImageProps & SelectedButtonProps;
type MBTouchableIconProps = MBIconProps & SelectedButtonProps;

export function MBTouchableImage({
  disabled,
  onPress,
  testID,
  ...otherProps
}: MBTouchableImageProps) {
  return (
    <MBTouchableOpacity onPress={onPress} testID={testID}>
      <MBImage {...otherProps} />
    </MBTouchableOpacity>
  );
}

export function MBTouchableIcon({
  disabled,
  onPress,
  testID,
  ...otherProps
}: MBTouchableIconProps) {
  return (
    <MBTouchableOpacity onPress={onPress} disabled={disabled} testID={testID}>
      <MBIcon {...otherProps} />
    </MBTouchableOpacity>
  );
}
